import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import FeatureCategories from '../../containers/feature-categories';
import FeatureCategoryContainer from '../../blocks/feature-category-container';

const FeatureCategoriesBlock = props => <FeatureCategories {...props} />;
FeatureCategoriesBlock.displayName = 'FeatureCategories';

export default withDynamicComponents({
  componentWhitelist: [
    FeatureCategoryContainer,
  ],
  mapInputToOutput: [
    ['categories', 'categories'],
  ],
})(FeatureCategoriesBlock);



// WEBPACK FOOTER //
// ./src/blocks/feature-categories/index.jsx